import { UseQueryOptions, useQuery } from '@tanstack/react-query';

import api from '.';
import { BaseResponseDto } from '../dtos/responses/base.response.dto';
import { GetDepartmentsResponseDto } from '../dtos/responses/get-departments.response.dto';

const getDepartments = () => {
  return api<BaseResponseDto<GetDepartmentsResponseDto[]>, Error>(`/student/department`, {
    method: 'GET',
  });
};

export const useGetDepartments = (
  options?: Omit<UseQueryOptions<BaseResponseDto<GetDepartmentsResponseDto[]>, Error>, 'queryFn'>,
) => {
  return useQuery({
    queryKey: ['student', 'department'],
    queryFn: () => getDepartments(),
    ...options,
  });
};
